import { request } from "react-rb/request"

/**
 * List the account's commerce products.
 *
 * @return {object[]} The account's commerce products
 */
export async function listProducts() {
  const response = await request("/commerce/api/products")
  return response.data
}
